import PageHero from "../components/PageHero";
import PortfolioGrid from "../components/PortfolioGrid";
import CtaBanner from "../components/CtaBanner";
import { INTERIOR_IMAGES, HERO_IMAGE } from "../data/site";
import { useLang } from "../i18n/LanguageContext";

export default function Lavori() {
  const { t } = useLang();

  return (
    <div data-testid="lavori-page">
      <PageHero
        overline={t.projectsPage.overline}
        title={t.projectsPage.title}
        desc={t.projectsPage.desc}
        images={[INTERIOR_IMAGES.exterior, HERO_IMAGE]}
        imageAlt={t.projectsPage.imageAlt}
      />
      <section className="bg-white py-20 sm:py-24" data-testid="portfolio-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <PortfolioGrid />
        </div>
      </section>
      <CtaBanner />
    </div>
  );
}
